<template>
  <div class="table-responsive">
    <table class="table table-hover">
      <thead>
        <tr>
          <th class="col-xs-1">{{'date' | translate}}</th>
          <th class="col-xs-11">{{'report' | translate}} </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(news, index) in notifications">
          <td>
            {{news.created_at.split(' ')[0]}}
            <div class="small">
              <i class="fa fa-clock-o mr-5"></i>
              {{news.created_at.split(' ')[1]}}
            </div>
          </td>
          <td class="small">
            <div :class="['alert', `alert-${news.status}`, 'no-margin']">
              <h4><i :class="news.icon"></i> {{`alert_${news.status}` | translate}}</h4>
              <span v-for="line in news.message"><span v-html="line"></span> <template v-if="news.message.length > 1"><br/></template></span>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import moment from 'moment'
export default {
  props: ['notifications'],
  data () {
    return {
      moment: moment
    }
  },
  methods: {
  },
  watch: {
    model () {
      this.news = []
    }
  },
  mounted () {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/tools/Tables/NewsTable.vue